import { connect } from 'react-redux'
import Links from 'components/Links';


const LinksContainer = connect(
    state => state.user,
)(Links)

export default LinksContainer;


// WEBPACK FOOTER //
// ./src/containers/LinksContainer.jsx